import {yupResolver} from '@hookform/resolvers/yup'
import {FC, useEffect, useState} from 'react'
import {useForm} from 'react-hook-form'
import {Button} from '../../../../../../components/UI/Button'
import {Select} from '../../../../../../components/UI/Select'
import {SelectOption} from '../../../../../../models/utility.model'
import {useCentralServices} from '../../../../hooks/useCentralServices'
import {ChangeRoomFiltersModel} from '../../../../models/change-rooms.model'
import {changeRoomsSchema} from '../../../../schemas/change-rooms.schema'
import {TableChangeRoomsWrapper} from '../Tables/TableChangeRooms'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'

const FormChangeRooms: FC = () => {
  const {getCompanies, getClients, getSites, getCamps} = useCentralServices()
  const [company, setCompany] = useState<SelectOption[]>([])
  const [client, setClient] = useState<SelectOption[]>([])
  const [sites, setSites] = useState<SelectOption[]>([])
  const [camps, setCamps] = useState<SelectOption[]>([])
  const [filters, setFilters] = useState<ChangeRoomFiltersModel>({})
  const [hasClicked, setHasClicked] = useState<number>(0)
  const {isAllowed} = useHoteleria()

  const {
    // reset,
    // register,
    formState: {errors},
    control,
    setValue,
    handleSubmit,
    setError,
    // watch,
  } = useForm<ChangeRoomFiltersModel>({
    resolver: yupResolver(changeRoomsSchema),
  })

  useEffect(() => {
    getCompaniesFn()
  }, [])

  const getCompaniesFn = async () => {
    const data = await getCompanies({isCombo: true}, 1)
    if (data.length === 1) {
      setValue('CompaniaId', data[0].value as string)
      setError('CompaniaId', {})
      await getClientsFn(data[0].value as string)
    }
    setCompany(data)
  }

  const getClientsFn = async (companyId: string) => {
    const data = await getClients({isCombo: true, companiaId: companyId}, 1)
    if (data.length === 1) {
      setValue('ClienteId', data[0].value as string)
      setError('ClienteId', {})
      await getSitesFn(data[0].value as string)
    }
    setClient(data)
  }

  const getSitesFn = async (clientId: string) => {
    const data = await getSites({isCombo: true, clienteId: clientId}, 1)
    if (data.length === 1) {
      setValue('SiteId', data[0].value as string)
      setError('SiteId', {})
      await getCampsFn(data[0].value as string)
    }
    setSites(data)
  }

  const getCampsFn = async (siteId: string) => {
    const data = await getCamps({isCombo: true, siteId: siteId}, 1)
    if (data.length === 1) {
      setValue('CampamentoId', data[0].value as string)
      setError('CampamentoId', {})
    }
    setCamps(data)
  }

  ///
  const handleCompanyChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('CompaniaId', value)
    setValue('ClienteId', '')
    setValue('SiteId', '')
    setSites([])
    setValue('CampamentoId', '')
    setCamps([])
    setError('CompaniaId', {})

    getClientsFn(value)
  }

  const handleClientChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('ClienteId', value)

    setValue('SiteId', '')
    setValue('CampamentoId', '')
    setCamps([])
    setError('ClienteId', {})
    getSitesFn(value)
  }

  const handleSiteChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('SiteId', value)

    setValue('CampamentoId', '')

    getCampsFn(value)

    setError('SiteId', {})
  }

  const handleCampChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('CampamentoId', value)
    setError('CampamentoId', {})
  }

  const onSubmit = async (data: ChangeRoomFiltersModel) => {
    try {
      setHasClicked((prev) => prev + 1)
      setFilters(data)
    } catch (error) {
      // getSnackBar('Hubo un error', false)
    }
  }

  return (
    <div className='sdx_form card p-4'>
      {isAllowed('BUSCAR_ENCABEZADO') && (
        <>
          <div className='row'>
            <div className='mb-2 col-sm-12 col-lg-3'>
              <label className='required'>Compañia:</label>
              <Select
                control={control}
                name='CompaniaId'
                data={company}
                errors={errors}
                onChangeValue={handleCompanyChange}
              />
            </div>
            <div className='mb-2 col-sm-12 col-lg-3'>
              <label className='required'>Cliente:</label>
              <Select
                control={control}
                name='ClienteId'
                data={client}
                errors={errors}
                onChangeValue={handleClientChange}
              />
            </div>
            <div className='mb-2 col-sm-12 col-lg-3'>
              <label className='required'>Site:</label>
              <Select
                control={control}
                name='SiteId'
                data={sites}
                errors={errors}
                onChangeValue={handleSiteChange}
              />
            </div>
            <div className='mb-2 col-sm-12 col-lg-3'>
              <label className='required'>Campamento:</label>
              <Select
                control={control}
                name='CampamentoId'
                data={camps}
                errors={errors}
                onChangeValue={handleCampChange}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-sm-12 col-lg-3 d-flex pb-2'>
              <Button
                typeBtn='submit'
                label='Buscar'
                classNameProp='me-5 w-100px text-center d-flex justify-content-center'
                onClick={handleSubmit(onSubmit)}
              />
            </div>
          </div>
        </>
      )}
      {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
      {isAllowed('LISTAR') && (
        <TableChangeRoomsWrapper mainFilters={filters} hasClicked={hasClicked} />
      )}
    </div>
  )
}

export {FormChangeRooms}
